var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_83_1",
    "data-name": "Component 83 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.126,
    height: 22.126,
    viewBox: "0 0 21.126 22.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_282",
    "data-name": "Ellipse 282",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#f4f6f8",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M115.483,127.3a.968.968,0,0,0,.143-.012l4.021-.705a.234.234,0,0,0,.127-.067l10.134-10.134a.238.238,0,0,0,0-.337l-3.973-3.976a.242.242,0,0,0-.339,0L115.462,122.2a.243.243,0,0,0-.067.127l-.705,4.021a.8.8,0,0,0,.225.712A.81.81,0,0,0,115.483,127.3Zm1.611-4.169,8.671-8.669,1.752,1.752-8.671,8.669-2.125.375Zm13.266,6.178h-17.6a.764.764,0,0,0-.765.765v.861a.192.192,0,0,0,.191.191h18.743a.192.192,0,0,0,.191-.191v-.861A.764.764,0,0,0,130.361,129.309Z",
    transform: "translate(-110 -109)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.42499a6a.svg";
export { ForwardRef as ReactComponent };